import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PurchaseFormPage from "./PurchaseFormPage";
import PurchaseListPage from "./PurchaseListPage";
import { ProductProvider } from "../../store/productContext";
import { SupplierProvider } from "../../store/supplierContext";
import { CurrencyProvider } from "../../store/currencyContext";
import { PurchaseProvider } from "../../store/purchaseContext";

const PurchaseIndex: React.FC = () => (
    <ProductProvider>
        <SupplierProvider>
            <CurrencyProvider>
                <PurchaseProvider>
                    <Routes>
                        <Route path="form" element={<PurchaseFormPage />} />
                        <Route path="form/:id" element={<PurchaseFormPage />} />
                        <Route path="list" element={<PurchaseListPage />} />
                        <Route index element={<Navigate to="list" replace />} />
                        <Route path="*" element={<Navigate to="list" />} />
                    </Routes>
                </PurchaseProvider>
            </CurrencyProvider>
        </SupplierProvider>
    </ProductProvider>
);

export default PurchaseIndex;
